import { render, staticRenderFns } from "./RecommentWord.vue?vue&type=template&id=4e4ce18a&scoped=true&"
import script from "./RecommentWord.vue?vue&type=script&lang=js&"
export * from "./RecommentWord.vue?vue&type=script&lang=js&"
import style0 from "./RecommentWord.vue?vue&type=style&index=0&id=4e4ce18a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ce18a",
  null
  
)

export default component.exports